import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import { useTranslation } from 'react-i18next';
import { clientTypes } from 'appConstants';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const ClientTypeSelect: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const { t } = useTranslation('form');

	const clientType =
		clientTypes.find((el) => el.clientTypeID === customerForFullInfo?.clientType)?.clientTypeName || '';

	return (
		<FullInfoField
			label="clientTypeLabel"
			value={t(clientType) as string}
			prefixIcon="asSelect"
			prefixIconName={clientType}
		/>
	);
};
